import { Context, createContext, PropsWithChildren, useState } from "react";
import OperationTypes from "../../types";
import { CreateDamageFormTypes, DamageFormTypes } from "./Types";
import React from "react";

interface IDamageFormContext {
  eventTypes?: OperationTypes.Domain[];
  setEventTypes: (val: OperationTypes.Domain[]) => void;
  attachmentTypes?: OperationTypes.Domain[],
  setAttachmentTypes: (val: OperationTypes.Domain[]) => void;
  documentTypes?: DamageFormTypes.IDocumentTypeRow [],
  setDocumentTypes: (val: DamageFormTypes.IDocumentTypeRow[]) => void;
  msList?: DamageFormTypes.IMobilityStore[];
  setMsList: (val: DamageFormTypes.IMobilityStore[]) => void;
  rsList?: DamageFormTypes.IRepairShop[];
  setRsList: (val: DamageFormTypes.IRepairShop[]) => void;

  generalInfo?: DamageFormTypes.IGeneralInfo;
  setGeneralInfo: (val: DamageFormTypes.IGeneralInfo | undefined) => void;
  task1?: DamageFormTypes.ITask1;
  setTask1: (val: DamageFormTypes.ITask1 | undefined) => void;
  task2?: DamageFormTypes.ITask2;
  setTask2: (val: DamageFormTypes.ITask2 | undefined) => void;
  task3?: DamageFormTypes.ITask3;
  setTask3: (val: DamageFormTypes.ITask3 | undefined) => void;

  damageFormIds?: any[] | undefined;
  setDamageFormIds: (val: any[] | undefined) => void;

  attachments?: DamageFormTypes.IAttachments[];
  setAttachments: (val: DamageFormTypes.IAttachments[] | undefined) => void;
  
  photos?: DamageFormTypes.IAttachments[];
  setPhotos: (val: DamageFormTypes.IAttachments[] | undefined) => void;

}

export const ContextDamageForm: Context<IDamageFormContext> = createContext<IDamageFormContext>({
  setEventTypes: () => {},
  setDocumentTypes: () => {},
  setAttachmentTypes: () => {},
  setMsList: () => {},
  setRsList: () => {},
  setGeneralInfo: () => {},
  setTask1: () => {},
  setTask2: () => {},
  setTask3: () => {},
  setDamageFormIds: () => {},
  setAttachments: () => {},  
  setPhotos: () => {},
});

export const ProviderDamageForm = (props: PropsWithChildren<any>) => {
  const [eventTypes, setEventTypes] = useState<OperationTypes.Domain[] | undefined>();
  const [attachmentTypes, setAttachmentTypes] = useState<OperationTypes.Domain[] | undefined>();
  const [documentTypes, setDocumentTypes] = useState<DamageFormTypes.IDocumentTypeRow[] | undefined>();
  const [msList, setMsList] = useState<DamageFormTypes.IMobilityStore[] | undefined>();
  const [rsList, setRsList] = useState<DamageFormTypes.IRepairShop[] | undefined>();

  const [generalInfo, setGeneralInfo] = useState<DamageFormTypes.IGeneralInfo | undefined>();
  const [task1, setTask1] = useState<DamageFormTypes.ITask1 | undefined>();
  const [task2, setTask2] = useState<DamageFormTypes.ITask2 | undefined>();
  const [task3, setTask3] = useState<DamageFormTypes.ITask3 | undefined>();

  const [damageFormIds,setDamageFormIds] = React.useState<any>([]);

  const [attachments,setAttachments] = useState<DamageFormTypes.IAttachments[] | undefined>();
  const [photos,setPhotos] = useState<DamageFormTypes.IAttachments[] | undefined>();

  return (
    <ContextDamageForm.Provider
      value={{
        eventTypes,
        setEventTypes,
        documentTypes,
        setDocumentTypes,
        attachmentTypes,
        setAttachmentTypes,
        msList,
        setMsList,
        rsList,
        setRsList,
        generalInfo,
        setGeneralInfo,
        task1,
        setTask1,
        task2,
        setTask2,
        task3,
        setTask3,
        damageFormIds,
        setDamageFormIds,
        attachments,
        setAttachments,
		    photos,
        setPhotos
      }}
    >
      {props.children}
    </ContextDamageForm.Provider>
  );
};
